import { lazy } from 'react'

import { getEnv } from '@/libs/runtime-env/runtimeEnv'

const isTanStackRouterDevtools =
  getEnv('VITE_APP_TANSTACK_ROUTER_DEVTOOLS') === 'true'

export const TanStackRouterDevtools = !isTanStackRouterDevtools
  ? () => null
  : lazy(() =>
      import('@tanstack/react-router-devtools').then((res) => ({
        default: res.TanStackRouterDevtools,
      })),
    )
